import type { WelcomeMissionKind } from './welcomeMission.consts';
import type { UserQuestDto } from '@/queries/userQuest/userQuest.schema';

function normalizeMissionName(value: string) {
  return value.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
}

export function getWelcomeMissionKind(mission: UserQuestDto): WelcomeMissionKind | null {
  const normalizedCandidates = [
    mission.quest.name,
    mission.quest.questTemplateId,
    mission.questId,
  ].map(normalizeMissionName);

  if (normalizedCandidates.some(value => value.includes('get-the-app') || value.includes('app-install'))) {
    return 'get-the-app';
  }

  if (normalizedCandidates.some(value => value.includes('get-offers') || value.includes('adw-email') || value.includes('marketing-email'))) {
    return 'get-offers';
  }

  if (normalizedCandidates.some(value => value.includes('enable-push') || value.includes('push-notification'))) {
    return 'enable-push';
  }

  return null;
}

export function isMissionCompleted(mission: UserQuestDto) {
  return !!mission.completedAt;
}

export function areAllWelcomeMissionsCompleted(missions: UserQuestDto[]) {
  return missions.length > 0 && missions.every(isMissionCompleted);
}
